import { get, isEmpty } from 'lodash-es';

export const defaultActionsState = {
  btn: {
    cancel: {
      disable: true,
    },
    subscribe: {
      disable: true,
    },
    putonhold: {
      disable: true,
    },
    calculated: {
      disable: true,
    },
    print: {
      disable: true,
    },
  },
  hasCalculate: false,
  needCalculate: false,
};

export const diffPrevQuotation = (prevQuotation, nextQuotation, actionsState, newState) => {
  const fieldsRecalculate = ['date', 'release_date'];

  const state = {
    ...newState,
    hasCalculate: get(actionsState, 'hasCalculate', false),
    needCalculate: get(actionsState, 'needCalculate', false),
  };

  if (actionsState && (actionsState.hasCalculate || actionsState.needCalculate)) {
    state.btn.print.disable = actionsState.btn.print.disable;
  }

  fieldsRecalculate.forEach(field => {
    const prevValue = get(prevQuotation, field);
    const nextValue = get(nextQuotation, field);

    if (prevValue && nextValue && prevValue !== nextValue) {
      state.btn.subscribe.disable = true;
      state.btn.print.disable = true;
      state.needCalculate = true;
    }
  });

  if (isEmpty(nextQuotation.offer) && !state.needCalculate) {
    // state.btn.subscribe.disable = false;
    state.btn.print.disable = false;
  }

  return state;
};

export const asyncEvalActionsState = ({ validate, currentActionsState, quotations, quotation, actionsState }) => {
  const { id } = quotation;
  const currentQuotation = get(quotations, `[${id}]`);
  const status = get(currentQuotation, `quote_status`, 'default');
  if (status === 'submitted' || status === 'canceled') {
    const actionsStateDisabled = {
      btn: {
        cancel: {
          disable: true,
        },
        subscribe: {
          disable: true,
        },
        putonhold: {
          disable: true,
        },
        calculated: {
          disable: true,
        },
        print: {
          disable: status === 'canceled',
        },
      },
    };
    return { nextActionsState: actionsStateDisabled, asyncActionsState: actionsStateDisabled };
  }
  let nextActionsState = currentActionsState;
  const asyncActionsState = {
    btn: {
      subscribe: {
        disable:
          get(actionsState, 'btn.subscribe.disable') ||
          get(actionsState, 'needCalculate') ||
          !get(validate, 'data.subscription.valid', true),
      },
      calculated: {
        disable: get(actionsState, 'btn.calculated.disable') || !get(validate, 'data.quotation.valid', false),
      },
      print: {
        disable: get(actionsState, 'btn.print.disable') || !get(validate, 'data.print.valid', false),
      },
    },
    hasCalculate: get(actionsState, 'hasCalculate'),
    needCalculate: get(actionsState, 'needCalculate'),
  };
  nextActionsState = {
    btn: { ...get(defaultActionsState, 'btn'), ...get(nextActionsState, 'btn'), ...get(asyncActionsState, 'btn') },
    hasCalculate: get(actionsState, 'hasCalculate'),
    needCalculate: get(actionsState, 'needCalculate'),
  };

  return { nextActionsState, asyncActionsState };
};

export const evalActionsState = ({ prevQuotation, nextQuotation, actionsState }) => {
  const status = get(prevQuotation, `quote_status`, 'default');

  let state = {
    btn: {
      cancel: {
        disable: false,
      },
      subscribe: {
        disable: false,
      },
      putonhold: {
        disable: false,
      },
      calculated: {
        disable: false,
      },
      print: {
        disable: false,
      },
    },
  };

  let stateDiff;

  // evaluation based on quotation status
  switch (status) {
    case 'project':
    case 'pending':
      stateDiff = diffPrevQuotation(prevQuotation, nextQuotation, actionsState, state);

      state.hasCalculate = stateDiff.hasCalculate;
      state.needCalculate = stateDiff.needCalculate;
      state.btn = {
        ...get(state, 'btn'),
        subscribe: { ...get(stateDiff, 'btn.subscribe') },
        print: { ...get(stateDiff, 'btn.print') },
      };

      state.btn.cancel.disable = false;
      state.btn.putonhold.disable = false;

      if (!get(prevQuotation, 'offer') || isEmpty(prevQuotation.offer)) {
        state.btn.subscribe.disable = true;
        state.btn.print.disable = true;
      }

      break;

    case 'submitted':
      state.btn.cancel.disable = true;
      state.btn.subscribe.disable = true;
      state.btn.putonhold.disable = true;
      state.btn.calculated.disable = true;
      state.btn.print.disable = false;
      break;

    case 'canceled':
      state.btn.cancel.disable = true;
      state.btn.subscribe.disable = true;
      state.btn.putonhold.disable = true;
      state.btn.calculated.disable = true;
      state.btn.print.disable = true;
      break;

    // unkown status: do nothing
    default:
      state = defaultActionsState;
      break;
  }
  // evaluation based on quotation values
  // TODO: if quotation is loan
  return state;
};

export const evalExpanded = ({ quotations, quotation }) => {
  const { id } = quotation;
  const currentQuotation = get(quotations, `[${id}]`, 'default');
  const status = get(currentQuotation, `quote_status`, 'default');
  let expanded;

  // evaluation based on quotation status
  switch (status) {
    case 'project':
      expanded = {
        extra: true,
        loan: true,
        covered: true,
        transform: false,
        subscriptions: false,
        offer: false,
        all: false,
      };
      if (get(currentQuotation, 'offer') && !isEmpty(currentQuotation.offer)) {
        expanded = {
          extra: false,
          loan: false,
          covered: false,
          transform: true,
          subscriptions: true,
          offer: true,
          all: false,
        };
      }
      break;

    case 'submitted':
      expanded = {
        extra: false,
        loan: false,
        covered: false,
        transform: true,
        subscriptions: true,
        offer: true,
        all: false,
      };
      break;

    case 'canceled':
      expanded = {
        extra: false,
        loan: false,
        covered: false,
        transform: false,
        subscriptions: false,
        offer: false,
        all: false,
      };
      break;

    case 'pending':
      expanded = {
        extra: false,
        loan: false,
        covered: false,
        transform: false,
        subscriptions: false,
        offer: false,
        all: false,
      };
      break;
    // unkown status: do nothing
    default:
      expanded = {
        extra: false,
        loan: false,
        covered: false,
        transform: false,
        subscriptions: false,
        offer: false,
        all: false,
      };
      break;
  }
  // evaluation based on quotation values
  // TODO: if quotation is loan
  return expanded;
};
